import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {
  DeletePendingOrganizationMemberRequest,
  DeletePendingOrganizationUserRequest,
  GetOrganizationUsersRequest,
  GetSelfOrganizationUserRequest,
  OrganizationUser,
  PostGroupInvitationRequest,
  PostOrganizationInvitationRequest,
  SelfOrganizationUser
} from '../models/organization-user';
import {Simple200Response} from '../models/general';
import {map} from 'rxjs/internal/operators';
import {CustomQueryEncoderHelper} from './custom-query-encoder-helper';

@Injectable()
export class OrganizationUserService {

  constructor(private httpClient: HttpClient) {
  }

  getOrganizationUsers({organizationToken}: GetOrganizationUsersRequest): Observable<OrganizationUser[]> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url = `${environment.afbV2Host}org-users`;

    return this.httpClient
      .get<{ data: OrganizationUser[] }>(url, {headers})
      .pipe(
        map(response => response.data)
      );
  }

  getSelfOrganizationUser({organizationToken}: GetSelfOrganizationUserRequest): Observable<SelfOrganizationUser> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url = `${environment.afbV2Host}org-users/self`;

    return this.httpClient
      .get<SelfOrganizationUser>(url, {headers});
  }

  postOrganizationInvitation({organizationToken, email, role}: PostOrganizationInvitationRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${organizationToken}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.afbV2Host}orgs/self/invitations`;
    const body = {
      email,
      role
    };

    return this.httpClient
      .post<{ message: string }>(url, body, {headers});
  }

  postGroupInvitation({organizationToken, email, role, groupId}: PostGroupInvitationRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${organizationToken}`,
      'Content-Type': 'application/json'
    });

    const url = `${environment.afbV2Host}org-users/self/groups/${groupId}/invitations`;
    const body = {
      email,
      role
    };

    return this.httpClient
      .post<{ message: string }>(url, body, {headers});
  }

  deletePendingOrganizationUser({organizationToken, email}: DeletePendingOrganizationUserRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url = `${environment.afbV2Host}orgs/self/invitations`;
    // Using custom query param encoder to support alias(+) emails
    const params = new HttpParams({
      encoder: new CustomQueryEncoderHelper(),
      fromObject: {email}
    });

    return this.httpClient
      .delete<Simple200Response>(url, {headers, params});
  }

  deletePendingOrganizationMember({organizationToken, email, groupId}: DeletePendingOrganizationMemberRequest): Observable<Simple200Response> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${organizationToken}`});
    const url = `${environment.afbV2Host}org-users/self/groups/${groupId}/invitations`;
    // Using custom query param encoder to support alias(+) emails
    const params = new HttpParams({
      encoder: new CustomQueryEncoderHelper(),
      fromObject: {email}
    });

    return this.httpClient
      .delete<Simple200Response>(url, {headers, params});
  }
}
